import React from 'react';
import logo from '../../../assets/img/logo.png';
import logoDark from '../../../assets/img/logo_dark.png';
import myouwebLogo from '../../../assets/img/footer/myouweb.webp';
import livroReclamacoes from '../../../assets/img/footer/livro_reclamacoes.png';
import { Features } from '../../../assets/features/Features';
import { useLanguage } from '../../../context/LanguageContext';
import { useTheme } from '../../../context/ThemeContext';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routes/paths';

const Footer: React.FC = () => {
  // Use language from context
  const { language } = useLanguage();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  return (
    <footer id="footer" className="footer light-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-12 col-lg-3 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <img src={isDarkMode ? logoDark : logo} alt="Logo" style={{ height: '55px', width: 'auto' }} />
            </a>
            <div className="footer-contact pt-3">
              <a 
                href="https://maps.google.com/?q=Av.+Eng.+Duarte+Pacheco,+642,+4445-416+Ermesinde" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <p style={isDarkMode ? { color: '#f3f4f6' } : {}}>{Features.footer.contact.address.line1[language]}</p>
                <p style={isDarkMode ? { color: '#f3f4f6' } : {}}>{Features.footer.contact.address.line2[language]}</p>
              </a>
              <p className="mt-3" style={isDarkMode ? { color: '#f3f4f6' } : {}}>
                <strong style={isDarkMode ? { color: '#ffffff' } : {}}>{Features.footer.contact.phone.label[language]}</strong> 
                <a
                  href={`tel:${Features.footer.contact.phone.value[language].replace(/[^0-9+]/g, '')}`}
                  className="text-decoration-none"
                  style={isDarkMode ? { color: '#f3f4f6' } : {}}
                >
                  {Features.footer.contact.phone.value[language]}
                </a>
              </p>
              <p style={isDarkMode ? { color: '#d1d5db' } : {}}>
                <small>{Features.footer.contact.phone.note[language]}</small>
              </p>
              <p style={isDarkMode ? { color: '#f3f4f6' } : {}}>
                <strong style={isDarkMode ? { color: '#ffffff' } : {}}>{Features.footer.contact.email.label[language]}</strong> 
                <a 
                  href={`mailto:${Features.footer.contact.email.value[language]}`}
                  className="text-decoration-none"
                  style={isDarkMode ? { color: '#f3f4f6' } : {}}
                >
                  {Features.footer.contact.email.value[language]}
                </a>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="https://www.instagram.com/guiosteopata/" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
              <a href="https://www.facebook.com/clinicaosteopatiapt" target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
            </div>
            <a
              href="https://www.livroreclamacoes.pt/Inicio/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Livro de Reclamações"
              className="d-inline-block mt-4"
            >
              <img src={livroReclamacoes} alt="Livro de Reclamações" loading="lazy" style={{ width: '110px', height: 'auto' }} />
            </a>
          </div>

          <div className="col-6 col-lg-2 col-md-3 footer-links">
            <h4 style={isDarkMode ? { color: '#ffffff' } : {}}>{Features.footer.links.useful.title[language]}</h4>
            <ul>
              <li><Link to={ROUTES.HOME} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.useful.home[language]}</Link></li>
              <li><Link to={ROUTES.ABOUT_US} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.useful.aboutUs[language]}</Link></li>
              <li><Link to={ROUTES.GALLERY} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.useful.gallery[language]}</Link></li>
              <li><Link to={ROUTES.LOCATION} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.useful.location[language]}</Link></li>
              <li><Link to={ROUTES.ARBITRATION} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.useful.arbitration[language]}</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-4 col-md-6 footer-links">
            <h4 style={isDarkMode ? { color: '#ffffff' } : {}}>{language === 'pt' ? 'Abordagem Integrativa' : 'Integrative Approach'}</h4>
            <p style={isDarkMode ? { color: '#d1d5db' } : { color: '#6c757d' }}>
              {language === 'pt'
                ? 'Cada sessão combina fisioterapia, osteopatia, quiropraxia, auriculoterapia e outras abordagens de forma personalizada.'
                : 'Each session combines physiotherapy, osteopathy, chiropractic, auriculotherapy and other approaches in a personalized way.'}
            </p>
            <a href="#appointment" className="btn btn-sm btn-outline-primary mt-2" style={isDarkMode ? { color: '#d1d5db', borderColor: '#d1d5db' } : {}}>
              {language === 'pt' ? 'Marcar Consulta' : 'Book Appointment'}
            </a>
          </div>

          <div className="col-6 col-lg-3 col-md-3 footer-links">
            <h4 style={isDarkMode ? { color: '#ffffff' } : {}}>{Features.footer.links.legal.title[language]}</h4>
            <ul>
              <li><Link to={ROUTES.TERMOS} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.legal.termsConditions[language]}</Link></li>
              <li><Link to={ROUTES.PRIVACY} style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.links.legal.privacyPolicy[language]}</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container text-center mt-3">
        <p style={isDarkMode ? { color: '#d1d5db' } : {}}>
          <small>
            {language === 'en'
              ? 'Some images on this website were created or edited using artificial intelligence, for illustrative purposes. More information in our '
              : 'Algumas imagens deste website foram criadas ou editadas com recurso a inteligência artificial, para fins ilustrativos. Mais informação nos '}
            <Link to={ROUTES.TERMOS} style={isDarkMode ? { color: '#d1d5db' } : {}}>
              {language === 'en' ? 'Terms and Conditions' : 'Termos e Condições'}
            </Link>.
          </small>
        </p>
      </div>

      <div className="container copyright text-center mt-4">
        <p style={isDarkMode ? { color: '#f3f4f6' } : {}}>
          <span>{Features.footer.copyright.developedBy[language]}</span>
          <a href="https://myouweb.com/" target="_blank" rel="noopener noreferrer" className="px-1 d-inline-block">
            <img src={myouwebLogo} alt="MYOUWEB" style={{ height: '14px', width: 'auto', verticalAlign: 'top', marginTop: '3px' }} />
          </a>
          <span>| {new Date().getFullYear()}</span>
        </p>
        <div className="credits">
          <p style={isDarkMode ? { color: '#d1d5db' } : {}}>{Features.footer.copyright.subtitle[language]}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 